import { UserDetailResponse } from "@/web-client/api";
import { FC, PropsWithChildren, useMemo } from "react";
import UserProfile from "./UserProfile";
import TabsLayout from "@/components/TabsLayout";
import { UserTabType } from "@/consts/tabType";
import { TabProps } from "@/components/Tab";

interface Props {
  user: UserDetailResponse;
  tabType: UserTabType;
}

const UserDetailGroup: FC<PropsWithChildren<Props>> = ({
  user,
  tabType,
  children,
}): JSX.Element => {
  const tabs = useMemo<TabProps[]>(() => {
    return [
      {
        isCurrent: tabType === UserTabType.Project,
        to: `/users/${user.id}/projects`,
        label: "プロジェクト",
      },
      {
        isCurrent: tabType === UserTabType.Post,
        to: `/users/${user.id}/posts`,
        label: "写真",
      },
      {
        isCurrent: tabType === UserTabType.List,
        to: `/users/${user.id}/lists`,
        label: "リスト",
      },
      {
        isCurrent: tabType === UserTabType.Like,
        to: `/users/${user.id}/likes`,
        label: "Likes",
      },
    ];
  }, [user, tabType]);

  return (
    <div className="space-y-48 laptop:space-y-64">
      <div className="w-full px-20 max-w-[800px] mx-auto">
        <UserProfile user={user}></UserProfile>
      </div>
      <div className="px-16">
        <TabsLayout tabs={tabs}>{children}</TabsLayout>
      </div>
    </div>
  );
};

export default UserDetailGroup;
